<template>
  <div v-if="!isPrint">
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 내부 비상연락망 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="내부 비상연락망"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '직책', type: 'textarea' },
        { id: 'input3', title: '연락처', type: 'textarea' },
        { id: 'input4', title: '임무 및 역할', type: 'textarea' },
        { id: 'input5', title: '관련 웹사이트', type: 'link' },
      ]"
      v-model="form.inside"
    />

    <!-- 외부 비상연락망 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="외부 비상연락망"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '직책', type: 'textarea' },
        { id: 'input3', title: '연락처', type: 'textarea' },
        { id: 'input4', title: '임무 및 역할', type: 'textarea' },
        { id: 'input5', title: '관련 웹사이트', type: 'link' },
      ]"
      v-model="form.outside"
    />

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
  <print v-else :form="form" />
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import Print from "./Print.vue";

export default {
  components: {
    FieldSelectModule,
    TableCustom,
    FileUploadModule,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inside: [],
        outside: [],
        fileList: [],
      },
    };
  },
  created() {
    if (this.value) {
      const keys = Object.keys(this.value);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }
    }
  },
};
</script>
